import React from 'react';
import { Box, SpinnerProps } from 'grommet';
import { LoadingSpinner } from './LoadingSpinner';

const preventAll = (e: React.SyntheticEvent) => {
  e.stopPropagation();
};

export const LoadingLayout: React.FC<LoadingLayoutProps> = (_props) => (
  <Box
    fill
    background={{ color: 'black', opacity: 'medium' }} // Backdrop effect
    align="center"
    justify="center"
    style={{ position: 'fixed', top: 0, left: 0, zIndex: 100 }}
    onClick={preventAll}
    onMouseDown={preventAll}
    onMouseUp={preventAll}
    onTouchStart={preventAll}
  >
    <LoadingSpinner />
  </Box>
);

export type LoadingLayoutProps = SpinnerProps;
